import { render, staticRenderFns } from "./AnchorageoperationsModals.vue?vue&type=template&id=37518a04"
import script from "./AnchorageoperationsModals.vue?vue&type=script&lang=js"
export * from "./AnchorageoperationsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports